export function notInServer() {
  return typeof window !== 'undefined'
}

export function notInBrowser() {
  return !notInServer()
}
